<template>
  <div class="wrap talk" style="background-color: white;">
    <div class="container">
      <main class="content">
        <template v-if="isInqueryData">
          <section>
            <div style="padding: 30px 20px 0px 20px">
              <Header />
              <PrchModelInfo :ordInfo="ordInfo" />
              <BankInfo
                :ordInfo="ordInfo"
                :bankCdList="bankCdList"
                :isRegDone="isRegDone"
                :temp_om_account="temp_om_account"
                :isPassYn="isPassYn"
                :isForeigner="isForeigner"
                :orgCstmNm="orgCstmNm"
                @changeBankInfo="newVal => params = newVal"
                @certPass="certPass"
              />
              <EventInfo
                v-if="!isO2o"
                :isRegDone="isRegDone"
                :isEvent="isEvent"
                :temp_event="temp_event"
                @changeEventInfo="newVal => eventVal = newVal"
              />
              <Terms :isO2o="isO2o" :ordInfo="ordInfo" :isRegDone="isRegDone" @aggreAllAgrm="newVal => allAgrm = newVal" />
            </div>
          </section>
          <div v-if="!isRegDone" id="regBtnDiv" class="ui-buttons" style="padding: 20px;">
            <ul class="ui-buttons__list">
              <li class="ui-buttons__item">
                <button
                  type="button"
                  :disabled="!isEnable"
                  class="ui-button ui-basic-button"
                  @click="handleEnrollmentButtnClick"
                >
                  등록하기
                </button>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <div class="wrap talk">
            <header><h1><a class="logo"></a></h1></header>
            <div class="container">
              <main class="content">
                <article class="certification">
                  <section class="txt return">
                    <p class="return-txt">
                      주문 정보를 확인하지 못했습니다.
                      <br />
                      잠시 후 다시 시도해 주세요.
                      <br />
                      또는
                      <span>
                        <a href="tel: 1877-2660" style="color: #FFFCA8;">
                          고객센터
                        </a>
                      </span>
                      에 문의 바랍니다.
                    </p>
                  </section>
                </article>
              </main>
            </div>
          </div>
        </template>
        <div class="cs-center row row_ac row_jsc b-cs">
          <a
            href="tel: 1877-2660"
            class="en phone"
            style="padding-left:3px;"
            >
              <span class="qa" style="font-size:1.1rem;">
                고객센터 문의 :
                <span>
                1877-2660
              </span>
            </span>
          </a>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import Header from './components/Header.vue'
import PrchModelInfo from './components/PrchModlInfo.vue'
import BankInfo from './components/BankInfo.vue'
import EventInfo from './components/EventInfo.vue'
import Terms from './components/Terms.vue'

import utils from '@/modules/utils'

export default {
  name: 'TalkDeposit',
  components: {
    Header,
    PrchModelInfo,
    BankInfo,
    Terms,
    EventInfo
  },
  data: () => ({
    isRegDone: false,
    isPassYn: 'N',
    isForeigner: false,
    isEvent: false,
    isInqueryData: false,
    isShowDetail: true,
    allAgrm: false,
    bankCdList: [],
    temp_om_account: '',
    temp_event: '',
    eventVal: '',
    orgCstmNm: '',
    params: {
      cstmNm: '',
      bankCd: '',
      cstmAccnNum: null
    },
    certParams:{
      pass_type: '4',
      cstmClphNum: '',
      ordNumber: ''
    },
    ordInfo: {
      corporationCode: '',
      cstmNm: '',
      cstmClphNum: '',
      orderModel: '',
      payAddCmpAmt: '',
      proNum: '',
      ptnmNm: '',
      totPymtAmt: ''
    },
    isO2o:false
  }),
  computed: {
    isFormDone () {
      const { params } = this
      return Object.keys(params).filter(key => params[key]).length === Object.keys(params).length
    },
    isEnable () {
      return this.allAgrm && this.isFormDone
    },
    getOrderNumber () {
      return this.$route.query.ord_number
    },
    getPassYn () {
      return this.$route.query.passYn
    },
    isPrePaymentOrder () {
      return this.ordInfo.corporationCode === '020200'
    }
  },
  created () {
    this.getCommCodeByBankCd()
  },
  mounted () {
    const passYn = this.getPassYn
    this.isPassYn=passYn
    if ("Y" === passYn) {
      this.$Alert.alert('PASS 인증이 성공했습니다.')
      this.isForeigner = true
    } else if ("N" === passYn) {
      this.$Alert.alert('PASS 인증이 실패했습니다. 잠시 후 다시 시도해 주시기 바랍니다.')
      this.isForeigner = true
    }
    
      this.getOrderInfo()
  },
  watch: {
    temp_om_account (newVal, oldVal) {
      if (newVal !== oldVal) {
        const regex = /[^0-9]/g
        const result = `${newVal}`.replace(regex, '')
        this.temp_om_account = result
        this.params.cstmAccnNum = result
      }
    },
    temp_event (newVal, oldVal) {
        if (newVal !== oldVal) {
          const regex = /\s/g
          const result = `${newVal}`.replace(regex, '')
          this.temp_event = result
          this.params.eventVal = result
        }
      },
    isEnable (newVal) {
      if (document && newVal) {
        const regBtnDiv = document.getElementById('regBtnDiv')
        if (regBtnDiv) {
          const trgtHeight = regBtnDiv.offsetTop + 87
          window.scrollTo(0, trgtHeight)
        }
      }
    }
  },
  methods: {
    async getCommCodeByBankCd () {
      const params = {cmnsCdGrpId: 'BANK_CD'}
      const response = await this.$http.get('/api/appmgmt/public/common/code/list', {params})
      const codeList = []
      if (response && response.data && response.data.result) {
        response.data.result.forEach(c => {
          codeList.push({
            cmnsCd: c.cmnsCd,
            cmnsCdNm: c.cmnsCdNm
          })
        })
      }
      this.bankCdList = [...codeList]
    },
    async getOrderInfo () {
      const res = await this.$http.get(`/api/purchase/public/bank/getOrderInfo/${this.getOrderNumber}`)

      if (res) {
        const { data: { status, result } } = res
        if (status === '200' && result) {
          this.isInqueryData = true
          const { corporationCode, totPymtAmt, bankCd, cstmBankNm, decCstmAccnNum, cstmNm, pgrpCd, eventCode , sgstCtts, cstmClphNum, isO2o} = result
          this.isO2o = isO2o > 0 ? true : false;
          if (bankCd && cstmBankNm && decCstmAccnNum && cstmNm) {
            this.isRegDone = true
            this.temp_om_account = decCstmAccnNum
            this.temp_event = sgstCtts
            this.params = {
              cstmNm,
              bankCd
            }
          }
          this.orgCstmNm = cstmNm
          this.certParams.cstmClphNum = cstmClphNum
          this.isEvent = eventCode === '1'
          if(this.isO2o){
              this.allAgrm = true
            }
          const isPhone = pgrpCd === '101'
          const isPrePaymentOrder = corporationCode === '020200'
          const prePaymentMsg = '계좌 입력 후 30분 이내 지급'
          const postPaymentMsg = '최종 판매 동의 시 입금'
          const postPymtAmtMsg = `검수 후 안내 예정<br />*검수가 완료되어 가격이 최종 확정되면 별도 알림톡을 보내드립니다.`
          this.ordInfo = {
            ...result,
            isPhone,
            depositMsg: this.isO2o ? '계좌입력 후 3분 이내 지급' : isPhone ? (isPrePaymentOrder ? prePaymentMsg : postPaymentMsg) : '최종 판매동의시 30분이내 지급',
            pymtAmtMsg: this.isO2o ? utils.numberComma(totPymtAmt) :  isPrePaymentOrder ? utils.numberComma(totPymtAmt) : postPymtAmtMsg,
            prchClsfName: isPhone ? '휴대폰 종류' : '판매제품'
          }
        } else {
          this.$Alert.alert('주문 정보를 확인하지 못했습니다. 잠시 후 다시 시도해 주시기 바랍니다.')
            .then(() => {
              this.closeWindow()
            })
        }
      }
    },
    closeWindow () {
      const ua = navigator.userAgent.toLowerCase()

      console.log('====> Close Calling!!! ')

      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    },
    async handleEnrollmentButtnClick () {
      if (!this.isEnable) {
        this.$Alert.alert('입금계좌 정보 입력과 약관동의는 필수 입니다.')
        return
      }
  	  // 1. 예금주 정보 확인
      const bankObj1 = this.bankCdList.find(
        c => c.cmnsCd === this.params.bankCd
      )
      const passYn = this.getPassYn
      if ("Y" === passYn) {

        if (this.isNotEmpty(bankObj1 ? bankObj1.cmnsCd : '') && this.isNotEmpty(this.params.cstmAccnNum) && this.isNotEmpty(this.params.cstmNm)) {
          const AccnInfoParams = {
            bankCd: bankObj1.cmnsCd,
            cstmAccnNum: this.params.cstmAccnNum,
            cstmNm: this.params.cstmNm
          }

          var rsltCstmNm = ""
          var rsltMsg = "예금주명 조회중 오류가 발생했습니다."
          const accnOwnrInqrRes = await this.$http.post('/api/purchase/public/bank/isMatchAccnInfoDetail', AccnInfoParams)
          if (accnOwnrInqrRes) {
            const { data: { status, result } } = accnOwnrInqrRes
            if (status === '200' && this.isNotEmpty(result) ) {
              rsltCstmNm = result.rsltCstmNm
              rsltMsg = result.rsltMsg
            }
          }

          if ( rsltCstmNm == undefined || rsltCstmNm == "" ) {
            this.$Alert.alert(rsltMsg)
            return
          }

          const confirmAccount = await this.$Alert.confirm("예금주 : "+rsltCstmNm+"<br/>"
            +"은행명 : "+bankObj1.cmnsCdNm+"<br/>"
            +"계좌번호 : "+this.params.cstmAccnNum+"<br/>이체를 진행하시겠습니까?")

          if (!confirmAccount) {
            return
          } else {
            this.params.cstmNm = rsltCstmNm
          }

        } else {
          this.$Alert.alert('계좌정보를 입력해주세요.')
          return
        }

      } else if ("N" === passYn) {
        this.$Alert.alert('PASS 인증을 진행해주세요.')
        return
      } else if (this.isForeigner) {
        this.$Alert.alert('PASS 인증을 진행해주세요.')
        return
      } else {
        const accnOwnrInqrRes = await this.$http.post('/api/purchase/public/bank/isMatchAccnInfo', this.params)
        let isMatch = false
        if (accnOwnrInqrRes) {
          const { data: { status, result } } = accnOwnrInqrRes

          if (status === '200') {
            isMatch = result.isMatch
          }
        }

        if (!isMatch) {
          this.$Alert.alert('인증 정보의 이름과 계좌정보의 이름이 같지 않습니다.')

          const eng = /^[a-zA-Z ]*$/
          if (eng.test(this.params.cstmNm)) {
            this.isForeigner = true
          } 
          return
        }
      }

      // 2. 계좌 등록 처리
      const bankObj = this.bankCdList.filter(obj => obj.cmnsCd === this.params.bankCd)
      const bankinfoUpdateRes = await this.$http.put('/api/purchase/public/bank/order/bankinfo-update', {
        ord_number: this.getOrderNumber,
        om_bank_name: bankObj[0].cmnsCdNm,
        om_account: this.params.cstmAccnNum,
        om_acc_name: this.params.cstmNm,
        event_val: this.eventVal.toUpperCase(),
        deposit_pass_yn: this.getPassYn
      })

      if (bankinfoUpdateRes) {
        const { data: { status, result } } = bankinfoUpdateRes

        if (status === '200') {
          const { cnt, error_msg } = result
          if (error_msg) {
            this.$Alert.alert(error_msg)
          }
          if (cnt) {
            this.$Alert.alert('등록되었습니다.').then(() => {
              this.closeWindow()
              this.$router.go(0)
            })
          }
        }
      }
    },
    async certPass() {
      this.certParams.ordNumber = this.getOrderNumber
      const rtn = await this.$http
        .post('/api/purchase/public/nice/cert/foreigner', {...this.$route.query, ...this.certParams})
        .then(res => {
          if (res.data && res.data.result) {
            const rs = res.data.result;
            console.log(rs);
            if ('success' === rs.msg) {
              const param = {};
              let tmpStrs = [];
              console.log(rs.cert_pass_url)
              if (rs.cert_pass_url) {
                if (rs.cert_pass_url.indexOf('?') > 0) {
                  const k = rs.cert_pass_url.substring(rs.cert_pass_url.indexOf('?') + 1).split('&');
                  for (let i in k) {
                    tmpStrs = k[i].split('=');
                    param[tmpStrs[0]] = tmpStrs[1]
                  }
                }
              }
              this.$router.push({name: 'CrtfPass', query: {...this.$route.query, ...param}})
            }
          }
        });
    },
    isNotEmpty(value) {
      return value !== undefined && value !== null && value !== '';
    }
  }
}
</script>

<style>
#toggle_cont {
  font-size: 0.8125rem;
  color: #2a2a2a;
  position: relative;
  display: inline-block;
  line-height: 25px;
}
#toggle_cont::after {
  content: "\E942";
  font-family: "xeicon";
  color: #2a2a2a;
  position: absolute;
  right: 0px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 1.125rem;
  font-weight: 600;
}
.slide-up {
  transition: all 0.25s;
}
.slide-up-enter-active {
  transition: all 0.25s ease;
}
.slide-up-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-up-enter,
.slide-up-leave-active {
  opacity: 0;
  transform: translateY(100%);
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/sale/TalkDeposit.vue